'use strict';
import get from 'lodash/get';
import {getAsset, getProject} from '../../app/model/reducers/state';
import {getCollection, getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import {ORGANIZATION_COLLECTION} from '../../organizations/domain/config';
import {getCreateChildErrorMessage} from '../../projects/utils';
import * as TASK_TYPE from '../enums/TASK_TYPE';
import {TaskType} from '../enums/TaskType';
import {logger} from './logger';


TasksCreateController.$inject = [
  '$modal',
  '$scope',
  '$miscUtils',
  '$toast',
  '$ngRedux',
  '$filter',
  '$permissions',
  'ProjectDomain',
  'TaskDomain',
  'AssetTaskDomain',
  'selectorsService',
  'MilestoneDomain',
  'OrganizationDomain',
  'project',
  'milestone',
  'ctrlConfig',
];

export function TasksCreateController(
  $modal,
  $scope,
  $miscUtils,
  $toast,
  $ngRedux,
  $filter,
  $permissions,
  ProjectDomain,
  TaskDomain,
  AssetTaskDomain,
  selectorsService,
  MilestoneDomain,
  OrganizationDomain,
  project,
  milestone,
  ctrlConfig,
) {

  /*****************************************************************************************************************
   * Initialize
   ****************************************************************************************************************/
  const vm = $scope.addTask = initViewModel(this);

  vm.save = $miscUtils.blockPromise(save);
  vm.selectPersonnel = selectPersonnel;
  vm.onPersonSelect = onPersonSelect;
  vm.cancel = $modal.cancel.bind($modal);

  vm.isTemplate = ctrlConfig.taskType === TaskType.TEMPLATE;

  loadMilestoneList();

  $scope.$watch(function () {
    return vm.model.isPrivate;
  }, function (isPrivate) {
    if (isPrivate)
      vm.model.assignedTo = null;
  });


  /*****************************************************************************************************************
   * Controller Actions
   ****************************************************************************************************************/

  function selectPersonnel() {
    const assignment = vm.model.assignedTo || null;

    const targetProject = getCollection(project).indexOf('asset') > -1 ? project.project : project;
    return $permissions.getTargetForProject(targetProject)
      .then(target =>
        getCollection(target) === ORGANIZATION_COLLECTION
          ? selectorsService.selectPersonnel(assignment)
          : selectorsService.selectPersonnelForTarget(target, assignment)
      )
      .then(onPersonSelect)
      .catch(err => {
        // eslint-disable-next-line max-len
        logger.error({err}, 'TasksCreateController.selectPersonnel: error occurred while selecting a new assignment');
      });
  }

  function onPersonSelect(person) {
    vm.model.assignedTo = person;
  }

  // TODO: need to handle edge cases where user first saves a asset level task then changes options and re-saves? (I don't think the view allows this right now)
  function save() {
    // You are not allowed to assign a task that is being created private unless you are assigning it to yourself
    // TODO: add support for assigning it to yourself
    if (vm.model.isPrivate)
      vm.model.assignedTo = null;

    if (!vm.model.$validate()) {
      console.warn(vm.model.$errors);
      return Promise.reject(vm.model.$errors);
    }

    return vm.model.create(vm.options)
      .then(function (newTask) {
        __showSuccessMessage();
        if (newTask) {
          return $modal.hide(newTask);
        } else {
          return $modal.hide();
        }
      })
      .catch(function (error) {
        console.error(error);
        showErrorMessage(error);
      });
  }

  function showErrorMessage(error) {
    const messageId = getCreateChildErrorMessage(error && (error.statusCode || error.status));

    if (messageId) {
      $toast.showI18nMessage({
        messageId,
        i18nMessageParams: {child: 'projects.child.task_simple.label'},
        type: $toast.TOAST_TYPES.error,
      });
    }
  }

  function __showSuccessMessage() {
    $toast.showI18nMessage({
      messageId: 'tasks.create.success.message',
      type: 'info',
    });
  }

  function loadMilestoneList() {
    // load the milestone list for the in-place editor's milestone property
    if (ctrlConfig.taskType === TASK_TYPE.SITE && getLink(vm.model, 'task').id) {
      vm.editMilestone = false;
      vm.getMilestone = function () {
        if (get(vm, 'model.task.milestone')) {
          return vm.model.task.milestone.toString();
        } else {
          return 'Misc';
        }
      };
    } else {
      vm.editMilestone = true;
      initMilestoneFilter();
    }
  }

  function initMilestoneFilter() {
    const rootState = $ngRedux.getState();
    const milestoneFilterSubscription = ProjectDomain
      .$getMilestonesList(getId(getProject(rootState)))
      .$toObservable({onChildChanged: false})
      .map(MilestoneDomain.filterMilestoneListByTaskType(ctrlConfig.taskType))
      .map($filter.toArray)
      .map($filter.$sortByName)
      .subscribe(function (milestones) {
        $scope.$evalAsync(function () {
          vm.milestones = milestones;
        });
      });

    $scope.$on('$destroy', milestoneFilterSubscription.unsubscribe.bind(milestoneFilterSubscription));
  }


  /*****************************************************************************************************************
   * Presentation Logic
   ****************************************************************************************************************/

  function initViewModel(vm) {
    const rootState = $ngRedux.getState();
    const asset = getAsset(rootState);
    switch (ctrlConfig.taskType) {
      case TASK_TYPE.SITE:
        vm.model = AssetTaskDomain.$factory.create();
        vm.model.assetProject = project; // this will be the current selected assetProject
        vm.model.ast = getId(asset);

        vm.options = {
          showProjectAssetTaskOptions: true,
          showAssetTaskOptions: true,
          addToProject: false, // create as Task and propagate to this AssetProject only
          addToExisting: false, // create as Task and propagate to all existing AssetProjects
        };
        break;
      case TASK_TYPE.PROJECT:
        vm.model = TaskDomain.$factory.create();
        vm.model.assetSpecific = false;

        vm.options = {};
        break;
      case TASK_TYPE.PROJECT_SITE:
        vm.model = TaskDomain.$factory.create();
        vm.model.assetSpecific = true;

        vm.options = {
          showProjectAssetTaskOptions: true,
          addToExisting: true, // create as Task and propagate to all existing AssetProjects
          /* TODO: status conditionals are not supported yet. options may need to modified once then are*/
          excludeComplete: false, // options that filter existing AssetProjects in some way
        };
        break;
    }

    vm.model.project = getProject(rootState);

    if (milestone) {
      vm.model.milestone = milestone;
    }

    return vm;
  }
}



// WEBPACK FOOTER //
// ./src/js/tasks/controllers/TasksCreateController.js